<template>
  <LineChartGenerator
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy';

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, LineElement, LinearScale, CategoryScale, PointElement);

export default {
  name: 'LineChart',
  components: {
    LineChartGenerator,
  },
  props: {
    chartId: {
      type: String,
      default: 'line-chart',
    },
    datasetIdKey: {
      type: String,
      default: 'label',
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: '',
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
    chartLabels: {
      type: Array,
    },
    chartDataProp: {
      type: Array,
    },
  },
  data() {
    return {
      chartData: {
        labels: [],
        datasets: [
          {
            label: '',
            borderColor: 'black',
            fill: false,
            backgroundColor: 'black',
            data: [],
            borderWidth: 1,
            radius: 0,
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            grid: {
              display: false,
            },
            drawBorder: false,
          },
          y: {
            grid: {
              drawBorder: false,
            },
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          title: {
            display: true,
            text: 'Data',
            position: 'bottom',
            align: 'end',
          },
        },
      },
    };
  },
  created() {
    this.setChart();
  },
  methods: {
    setChart() {
      if (this.chartLabels && this.chartDataProp) {
        this.chartLabels.forEach((chartLabel) => {
          this.chartData.labels.push(chartLabel.y);
        });
        this.chartDataProp.forEach((dataProp) => {
          this.chartData.datasets[0].data.push(dataProp.x);
        });
      }
    },
  },
};
</script>
